import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33bac4f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-[24px]" }
const _hoisted_2 = { class: "field-desc" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "mt-[24px]" }
const _hoisted_5 = { class: "field-desc" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "mt-[24px]" }
const _hoisted_8 = { class: "field-desc" }
const _hoisted_9 = { class: "absolute bottom-0 h-[56px]" }

import { IncrediField, IncrediTooltip, useIncrediForm } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import FormFooter from '@/components/common/dialogs/settingsActiveDirectoryDialog/formFooter.vue';
import { Auth_Result_ErrorCode, External_Authentication_Type } from '@/graphql/codegen/generated/graphql';
import { computed, inject, onMounted, ref, watch } from 'vue';
import { IKActiveDirectory } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectory.injection.keys';
import { formActions } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectoryConst';
import { useI18n } from 'vue-i18n';
import { ResponseStatus } from '@/const/globals';


export default /*#__PURE__*/_defineComponent({
  __name: 'azureActiveDirectoryForm',
  emits: ["onCloseDialog", "showError", "activateInProcess", "deactivateInProcess"],
  setup(__props, { emit }: { emit: ({ (e: 'onCloseDialog', value: formActions): void; (e: 'showError', value: Auth_Result_ErrorCode): void; (e: 'activateInProcess'): void; (e: 'deactivateInProcess'): void }), expose: any, slots: any, attrs: any }) {

const activeDirectoryAPI = inject(IKActiveDirectory);

const { t } = useI18n();
const tooltipsModel = ref({
  tenantId: false,
  clientId: false,
  clientSecret: false,
});
const isActivateLoading = ref(false);

onMounted(() => {
  activeDirectoryAPI?.GQL_GetAD_Data?.refetch();
});

const { fields, form } = useIncrediForm({
  initialValues: {
    tenantId: activeDirectoryAPI?.azureAuthData?.value?.tenantId || '',
    clientId: activeDirectoryAPI?.azureAuthData?.value?.clientId || '',
    clientSecret: '', // TBD - ?
  },
  validationSchema: {
    tenantId: (value: any) => value?.length > 0 || t('settings.dialogs.connectActiveDirectory.formValidations.required'),
    clientId: (value: any) => value?.length > 0 || t('settings.dialogs.connectActiveDirectory.formValidations.required'),
    clientSecret: (value: any) => value?.length > 0 || t('settings.dialogs.connectActiveDirectory.formValidations.required'),
  },
});

const isUserEnabled = computed(() => activeDirectoryAPI?.azureAuthData?.value?.enabled || false);

const submitForm = form.handleSubmit(async values => {
  const payload = {
    tenantId: values.tenantId,
    clientId: values.clientId,
    clientSecret: values.clientSecret,
  };
  isActivateLoading.value = true;
  emit('activateInProcess');
  const result: any = await activeDirectoryAPI?.activateAD(External_Authentication_Type.AzureAd, payload);
  if (result?.data?.settings_externalAuth_azure_update?.result?.status === ResponseStatus.Ok) {
    emit('onCloseDialog', formActions.activate);
  } else {
    emit('showError', result?.data?.settings_externalAuth_azure_update?.result?.errorCode || Auth_Result_ErrorCode.GeneralError);
  }
  isActivateLoading.value = false;
});

watch(
  () => activeDirectoryAPI?.azureAuthData?.value,
  value => {
    fields.tenantId.value.value = value?.tenantId || '';
    fields.clientId.value.value = value?.clientId || '';
  },
);
const handleDeactivate = async () => {
  emit('deactivateInProcess');
  await activeDirectoryAPI?.deactivateActiveDirectory(External_Authentication_Type.AzureAd);
  activeDirectoryAPI?.GQL_GetAD_Data?.refetch();
};

return (_ctx: any,_cache: any) => {
  const _component_IncrediForm = _resolveComponent("IncrediForm")!

  return (_openBlock(), _createBlock(IbxScopedCss, { class: "!h-full" }, {
    default: _withCtx(() => [
      _createVNode(_component_IncrediForm, { onSubmit: _unref(submitForm) }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.azureActiveDirectory.tenantId.text')), 1),
                _createVNode(_unref(IncrediTooltip), {
                  modelValue: tooltipsModel.value.tenantId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tooltipsModel.value.tenantId) = $event)),
                  direction: "top-right",
                  hover: ""
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.azureActiveDirectory.tenantId.tooltip.a')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.azureActiveDirectory.tenantId.tooltip.b')), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass([tooltipsModel.value.tenantId ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_unref(IncrediField), {
                modelValue: _unref(fields).tenantId.value.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(fields).tenantId.value.value) = $event)),
                name: "azureServer",
                size: "tiny",
                onInput: _cache[2] || (_cache[2] = () => _unref(fields).tenantId.validate()),
                error: !!_unref(form).errors.value.tenantId,
                "error-message": _unref(form).errors.value.tenantId as any,
                disabled: _unref(isUserEnabled)
              }, null, 8, ["modelValue", "error", "error-message", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.azureActiveDirectory.clientId.text')), 1),
                _createVNode(_unref(IncrediTooltip), {
                  modelValue: tooltipsModel.value.clientId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tooltipsModel.value.clientId) = $event)),
                  direction: "top-right",
                  hover: ""
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.azureActiveDirectory.clientId.tooltip.a')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.azureActiveDirectory.clientId.tooltip.b')), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass([tooltipsModel.value.clientId ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_unref(IncrediField), {
                modelValue: _unref(fields).clientId.value.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(fields).clientId.value.value) = $event)),
                name: "azureServer",
                size: "tiny",
                error: !!_unref(form).errors.value.clientId,
                "error-message": _unref(form).errors.value.clientId as any,
                disabled: _unref(isUserEnabled),
                onInput: _cache[5] || (_cache[5] = () => _unref(fields).clientId.validate())
              }, null, 8, ["modelValue", "error", "error-message", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.azureActiveDirectory.clientSecret.text')), 1),
                _createVNode(_unref(IncrediTooltip), {
                  modelValue: tooltipsModel.value.clientSecret,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tooltipsModel.value.clientSecret) = $event)),
                  direction: "top-right",
                  hover: "",
                  "offset-x": -40
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.azureActiveDirectory.clientSecret.tooltip')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass([tooltipsModel.value.clientSecret ? 'uis uis-question-circle' : 'uil uil-question-circle', "question"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_unref(IncrediField), {
                modelValue: _unref(fields).clientSecret.value.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(fields).clientSecret.value.value) = $event)),
                name: "azureServer",
                "field-type": "password",
                size: "tiny",
                error: !!_unref(form).errors.value.clientSecret,
                "error-message": _unref(form).errors.value.clientSecret as any,
                disabled: _unref(isUserEnabled),
                onInput: _cache[8] || (_cache[8] = () => _unref(fields).clientSecret.validate())
              }, null, 8, ["modelValue", "error", "error-message", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(FormFooter, {
              "is-activate-loading": isActivateLoading.value,
              "is-user-enabled": _unref(isUserEnabled),
              "hide-submit-button": _unref(isUserEnabled),
              onSubmitForm: _unref(submitForm),
              onDeactivate: handleDeactivate
            }, null, 8, ["is-activate-loading", "is-user-enabled", "hide-submit-button", "onSubmitForm"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}
}

})